'use strict';
var parent = require('../../actual/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/get-own-property-symbols.js
// module id = 636
// module chunks = 13